"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_redux_1 = require("react-redux");
var activities_1 = require("../../helpers/activities");
var env_1 = require("../../helpers/env");
var scene_1 = require("../../helpers/scene");
var like_1 = require("./like");
// tslint:disable-next-line:no-var-requires
var styles = require('./scene.css');
var mapStateToProps = function (state) {
    return {
        scene: state.scene,
        user: state.user,
    };
};
var activityDisc = function (activities) {
    var act = activities[0];
    if (!act) {
        return '';
    }
    return (React.createElement("img", { className: styles.activity, src: env_1.env().staticSrcPath() + '/assets/images/activities/' + activities_1.mapActivitiesToImage(act.activityType) + '40PX.svg' }));
};
var location = function (activities) {
    var act = activities[0];
    if (!act) {
        return '';
    }
    return React.createElement("div", { className: styles.location }, act.locationName);
};
var getSocialUrl = function (source) {
    if (typeof window === 'undefined') {
        return '';
    }
    var url = window.location.toString();
    if (source) {
        url = url.replace(/(utm_source=)[^&]+/, '$1' + source);
    }
    return url;
};
var CopyToClipboard = /** @class */ (function (_super) {
    __extends(CopyToClipboard, _super);
    function CopyToClipboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CopyToClipboard.prototype.copyUrl = function (urlId) {
        // seems a bit dirty and typescript isn't a fan, but it works
        var copyUrl = document.getElementById(urlId);
        copyUrl.select();
        document.execCommand('Copy');
    };
    CopyToClipboard.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.holdInputs },
            React.createElement("div", { className: styles.label }, "Url"),
            React.createElement("div", { className: styles.holdCopier },
                React.createElement("input", { id: 'sceneUrl', type: 'text', readOnly: true, value: getSocialUrl() }),
                React.createElement("a", { onClick: function () { return _this.copyUrl('sceneUrl'); }, className: styles.copyButton }, "Copy")),
            React.createElement("div", { className: styles.label }, "Embed"),
            React.createElement("div", { className: styles.holdCopier },
                React.createElement("input", { type: 'text', readOnly: true, id: 'embedUrl', value: "<iframe src=\"" + getSocialUrl().replace('/scene/', '/embed/') + "\" allowfullscreen height=\"600\" width=\"800\"></iframe>" }),
                React.createElement("div", { onClick: function () { return _this.copyUrl('embedUrl'); }, className: styles.copyButton }, "Copy"))));
    };
    return CopyToClipboard;
}(React.Component));
var SceneComponent = function (_a) {
    var scene = _a.scene, user = _a.user, features = _a.features;
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.title }, scene.title),
        renderStudioLink(),
        React.createElement("div", { className: styles.subDetails },
            activityDisc(scene.activities),
            location(scene.activities),
            React.createElement("div", { className: styles.date }, moment(scene.created).fromNow()),
            React.createElement("div", { className: styles.sharing },
                React.createElement(like_1.LikeButton, null),
                React.createElement("a", { className: styles.share, target: '_', onClick: function () {
                        window.open('https://facebook.com/sharer/sharer.php?u=' + encodeURIComponent(getSocialUrl('facebook')));
                    } },
                    React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/facebook_color.svg' })),
                React.createElement("a", { className: styles.share, target: '_', onClick: function () {
                        window.open('https://twitter.com/share?url=' + encodeURIComponent(getSocialUrl('twitter')));
                    } },
                    React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/twitter_color.svg' })),
                React.createElement("a", { className: styles.share, onClick: function () {
                        window.location.href =
                            'mailto:?subject=' +
                                encodeURI('Check out this Scene of ' + scene.title || 'Check this out!') +
                                '&body=' +
                                encodeURI("I thought you'd like to see this amazing 3d adventure " + encodeURIComponent(getSocialUrl('email')));
                    } },
                    React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/email_color.svg' })),
                React.createElement("div", { className: styles.embed },
                    React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/embed_dark.svg' }),
                    React.createElement("div", { className: styles.embedMenu },
                        React.createElement("div", null,
                            React.createElement(CopyToClipboard, null),
                            React.createElement("div", { className: styles.smallPrint },
                                "First 500 embedded plays/month are free! Need more?",
                                React.createElement("a", { href: '/settings/pro' },
                                    "Upgrade to",
                                    React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/pro.svg' })))))))),
        React.createElement("div", { className: styles.description }, scene.description)));
    function renderStudioLink() {
        return scene_1.hasStudioAccess(user.handle === scene.accountId, features) ? (React.createElement("div", { className: styles.studioLink },
            "> ",
            React.createElement("a", { href: "/studio/" + scene.accountId + "/" + scene.sceneId }, "Edit in Studio"))) : null;
    }
};
exports.SceneDetails = react_redux_1.connect(mapStateToProps)(SceneComponent);
